enum RequestStatus {
  None,
  Pending,
  Failed,
  Success,
}
export default RequestStatus;
